<script lang="ts">
  import { groupDuplicates } from '@/Util/utils';
  import { type Exercise } from '@/Common/ActivityFunctions';
  import TodayDuplicateActivityCard from './TodayDuplicateActivityCard.svelte';
  import type { TodaysActivities } from '@/Common/constants';

  export let activity: Exercise;
  export let todaysActivities: TodaysActivities;
  export let isLoading = false;
  
  $: dupGroups = groupDuplicates(todaysActivities.activities);

</script>

{#if activity.duplicate_group_id && (dupGroups.get(activity.duplicate_group_id) || []).length > 1}
  <details>
    <summary class="list-item cursor-pointer text-sm text-primary hover:underline">View duplicates</summary>
    <div class="mt-2 space-y-2">
      {#each (dupGroups.get(activity.duplicate_group_id) || []) as d}
        {#if !d.is_currently_selected_duplicate}
          <TodayDuplicateActivityCard {todaysActivities} activity={d} bind:isLoading />
        {/if}
      {/each}
    </div>
  </details>
{/if}
